import React, { useRef } from "react";

import { AppMenuItem } from "Components/AppMenu";
import { AppMenu, ResourceMenuHandles } from "Components/AppMenu/AppMenu";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { DiaryType } from "Components/DiaryCalendar";
import { Button } from "Components/Form";
import { Color } from "Components/Form/Button";
import { Add as IconAdd } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { useAppState } from "Context/StateContext";
import { isShowAction } from "Util/permissions";
import { isMoving } from "Util/validation";

type Props = {
  createPermission: {
    team: boolean,
    task: boolean,
    placeholder: boolean,
  }
};

export const DiaryHeaderCreationMenu = (props: Props) => {
  const {createPermission} = props;
  const {currentUser} = useAppState();
  const onClickAndCloseOptions = (onClick: () => void) => {
    onClick();
    newCreationMenuRef.current?.close();
  };
  const {
    currentDate: actualDate,
    crewsFiltered,
    createTaskRef,
    createPlaceholderTaskRef,
    createCrewModalRef,
    viewMode,
  } = useOperationDespatchContext();
  const newCreationMenuRef = useRef<ResourceMenuHandles | null>(null);
  const { t: translate } = useTranslation();

  return (
    <React.Fragment>
      <Button
        customColor={Color.SECONDARY_DARK}
        startIcon={<IconAdd />}
        onClick={(event) => newCreationMenuRef.current?.open(event.currentTarget)}
      >
        {translate("new")}
      </Button>

      <AppMenu ref={newCreationMenuRef}>
        {
          (
            isShowAction(currentUser, createPermission.team) ||
            (!isMoving(currentUser?.company) &&
            viewMode === DiaryType.RESOURCES)
          ) && (
            <AppMenuItem
              onClick={() =>
                onClickAndCloseOptions(() => createCrewModalRef.current?.open(actualDate))
              }
            >
              {translate("newTeam")}
            </AppMenuItem>
          )
        }
        {
          isShowAction(currentUser, createPermission.task) && <AppMenuItem
            onClick={() => onClickAndCloseOptions(() => createTaskRef.current?.open(crewsFiltered))}
          >
            {translate("newTask")}
          </AppMenuItem>
        }
        {
          isShowAction(currentUser, createPermission.placeholder) && <AppMenuItem
            onClick={() =>
              onClickAndCloseOptions(() => createPlaceholderTaskRef.current?.open(crewsFiltered))
            }
          >
            {translate("newPlaceholderTask")}
          </AppMenuItem>
        }
      </AppMenu>
    </React.Fragment>
  );
};
